/* eslint-disable no-console */
import { AxiosInstance } from 'axios';

type EmailMktToken = {
  token: string;
  expiresAt: number;
};

const AUTH_TOKEN_KEY = 'EMAIL_MKT_API_TOKEN';

export const getEmailMktToken = async (
  axiosInstance: AxiosInstance,
): Promise<string> => {
  let tokenObject: EmailMktToken | null = null;
  try {
    tokenObject = JSON.parse(
      global.localStorage.getItem(AUTH_TOKEN_KEY) || 'null',
    ) as EmailMktToken;
  } catch (error) {
    console.error(
      'Error parsing email marketing token from localStorage:',
      error,
    );
    global.localStorage.removeItem(AUTH_TOKEN_KEY);
    tokenObject = null;
  }

  if (!tokenObject) {
    try {
      const {
        data: { data },
      } = await axiosInstance.get('/marketing/requisitar-token');
      const newToken: EmailMktToken = {
        token: data.token,
        expiresAt: Date.now() + data.expiresIn * 1000, // Convert expiresIn to milliseconds
      };
      global.localStorage.setItem(AUTH_TOKEN_KEY, JSON.stringify(newToken));
      return data.token;
    } catch (error) {
      console.error('Error fetching email marketing token:', error);
      throw error;
    }
  }
  const { expiresAt } = tokenObject;
  if (Date.now() >= expiresAt) {
    global.localStorage.removeItem(AUTH_TOKEN_KEY);
    return getEmailMktToken(axiosInstance);
  }
  return tokenObject.token;
};
